export default __webpack_public_path__ + "static/media/cooming_soon.ea6db4b6.svg";